import React, { useEffect } from 'react';
import { convertToBgImage } from 'gbimage-bridge';
import BackgroundImage from 'gatsby-background-image';

import { useNavbar } from '../hooks/useNavbar';

import BlockContent from './BlockContent';
import Illustration from './Illustration';
import Wrapper from './Wrapper';

export default function Header({ header }) {
  const { illustration, isNavbarTransparent, blockContent } = header || {};

  const { setIsNavbarTransparent } = useNavbar();
  const { file, isBackgroundImage } = illustration || {};

  useEffect(() => {
    setIsNavbarTransparent(isNavbarTransparent);
  }, [isNavbarTransparent]);

  const bgImage = convertToBgImage(file?.gatsbyImageData);

  const style = `header ${!isBackgroundImage ? '--secondary' : ''}`;

  return (
    <Wrapper
      condition={isBackgroundImage && bgImage}
      wrapper={(children) => (
        <BackgroundImage {...bgImage}>{children}</BackgroundImage>
      )}
    >
      <header className={style}>
        <div className="wrapper">
          <BlockContent content={blockContent} />
          {!isBackgroundImage && <Illustration illustration={illustration} />}
        </div>
      </header>
    </Wrapper>
  );
}
